module.exports = __webpack_public_path__ + "img/mute_video.89455ac4.svg";